var classes = {"productCardImageWrapper":"ruzMG","productCardActions":"Qj9yq","quickViewButton":"c7vsI","shareButton":"lWEpv"};

export { classes as default };
